import React from 'react'
import styled from 'styled-components'

const Card = styled.div`
    width: 650px;
    border-radius: 10px;
    box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
    padding: 12px 16px;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease-in-out;
    &:hover{
        box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
        transform: translateY(-5px);
    }
    @media only screen and (max-width: 768px){
        padding: 10px;
        gap: 8px;
        width: 300px;
    }
    border: 0.1px solid #854CE6;
`

const Top = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    align-items: center;
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.text_primary + 99};
    @media only screen and (max-width: 768px){
        font-size: 14px;
    }
`

const Issuer = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.text_secondary + 99};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`

const Date = styled.div`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary + 80};
    @media only screen and (max-width: 768px){
        font-size: 10px;
    }
`

const Description = styled.div`
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary + 99};
    margin-bottom: 10px;
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`

const CertificateButton = styled.a`
    display: inline-block;
    padding: 8px 16px;
    background-color: #854CE6;
    color: white;
    border-radius: 8px;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    transition: all 0.3s ease-in-out;
    &:hover{
        background-color: #6c3ec0;
        transform: scale(1.05);
    }
    @media only screen and (max-width: 768px){
        font-size: 12px;
        padding: 6px 12px;
    }
`

const CertificationCard = ({ certification }) => {
    return (
        <Card>
            <Top>
                <Body>
                    <Title>{certification.title}</Title>
                    <Issuer>{certification.issuer}</Issuer>
                    <Date>{certification.date}</Date>
                </Body>
            </Top>
            <Description>
                {certification.description}
            </Description>
            <CertificateButton href={certification.certificate} target="_blank" rel="noopener noreferrer">
                View Certificate
            </CertificateButton>
        </Card>
    )
}

export default CertificationCard
